/**
 * SearchResultCards — WebSearch 工具结果的链接卡片列表
 *
 * 样式复用 chat-markdown.tsx 的 favicon 卡片设计：
 * Google S2 favicon + 标题 + 域名标签。
 */

import { memo } from 'react'

const RE_WWW = /^www\./

interface SearchLink {
  title: string
  url: string
}

export const SearchResultCards = memo(function SearchResultCards({
  links,
}: {
  links: SearchLink[]
}) {
  if (links.length === 0) return null

  return (
    <div className="flex flex-wrap gap-1.5">
      {links.map((link, i) => {
        let domain = ''
        try {
          domain = new URL(link.url).hostname.replace(RE_WWW, '')
        } catch {
          domain = link.url.slice(0, 30)
        }
        const faviconUrl = `https://www.google.com/s2/favicons?sz=32&domain=${domain}`

        return (
          <a
            key={i}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 rounded-lg border border-border/60 bg-secondary/60 px-2 py-1 text-[0.75rem] text-foreground/90 no-underline shadow-sm transition-all duration-200 hover:bg-secondary/80 hover:border-border/80 hover:shadow-md hover:-translate-y-px active:scale-[0.97] active:shadow-sm max-w-[280px]"
          >
            <img
              src={faviconUrl}
              alt=""
              className="h-3 w-3 rounded-sm shrink-0"
              loading="lazy"
              onError={(e) => { (e.target as HTMLImageElement).style.display = 'none' }}
            />
            <span className="truncate">{link.title || domain}</span>
            {link.title && (
              <span className="text-muted-foreground/40 text-[0.65rem] shrink-0">{domain}</span>
            )}
          </a>
        )
      })}
    </div>
  )
})
